import matchSorter from 'match-sorter'
import Diacritic from 'diacritic'

export function getKey (itemToString, item) {
  if (typeof item === 'string') return item
  if (item.key) return item.key
  if (item.id) return item.id
  if (itemToString) return itemToString(item)
  return item
}

export function renderItem ({ renderItem, itemToString, item }) {
  if (renderItem) return renderItem(item)
  if (itemToString) return itemToString(item)
  return item
}

export function reorderItems ({
  items,
  inputValue,
  itemToString,
  filterOnly = false
}) {
  if (!inputValue) return items

  if (filterOnly) {
    return filterItems(items, inputValue, itemToString)
  } else {
    return sortAndFilterItems(items, inputValue, itemToString)
  }
}

function filterItems (items, inputValue, itemToString) {
  const normalizedInputValue = Diacritic.clean(inputValue).trim().toLowerCase()
  return items.filter(item =>
    getItemString(itemToString, item).includes(normalizedInputValue)
  )
}

function getItemString (itemToString, item) {
  const itemString = itemToString ? itemToString(item) : item
  return Diacritic.clean(itemString).toLowerCase()
}

function sortAndFilterItems (items, inputValue, itemToString) {
  const options = {
    keys: itemToString ? [itemToString] : undefined
  }
  return matchSorter(items, inputValue.trim(), options)
}

export function isSelected ({ selectedItem, item, itemToString }) {
  if (!selectedItem || selectedItem.length === 0) return false

  if (typeof selectedItem === 'string') {
    return selectedItem === item
  }

  if (selectedItem.length) {
    const selectedItemKeys = selectedItem.map(item =>
      getKey(itemToString, item)
    )
    const itemKey = getKey(itemToString, item)
    return selectedItemKeys.includes(itemKey)
  }

  return getKey(itemToString, selectedItem) === getKey(itemToString, item)
}
